import { ref } from 'vue';

const isRedirecting = ref(false);
const returnTo = ref<string | null>(null);

export function useLegalGate() {
    function requestLegalAcceptance(currentPath: string) {
        if (isRedirecting.value) return;
        isRedirecting.value = true;
        returnTo.value = currentPath;
    }

    function consumeReturnTo(): string | null {
        const path = returnTo.value;
        returnTo.value = null;
        isRedirecting.value = false;
        return path;
    }

    return {
        requestLegalAcceptance,
        consumeReturnTo,
        isRedirecting,
        returnTo,
    };
}
